export enum Theme {
  DARK = 'BLACK-THEME',
  LIGHT = 'DEFAULT-THEME',
}
